// hooks/useViewEmployee.tsx
import { useEffect, useState } from 'react';
import ApiService from '../../../../../service/ApiService';
import { apiPaths } from '../../../../../service/apiPaths';
import { IEmployees } from '../../Employee.props';

const useViewEmployee = (employee: IEmployees) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [employeeData, setEmployeeData] = useState<any | null>(null);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await ApiService({
        method: 'GET',
        endpoint: apiPaths.getAllEmployees,
      });
      const data = result.data.find((employees: { employeeId: any; }) => employees?.employeeId === employee || null)
      setEmployeeData(data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally{
      setLoading(false)
    }
  };
  return { employeeData , loading};
};

export default useViewEmployee;
